export function getFiveMinutesRandomNumber() {
    return Math.floor(Date.now() / 5 / 1000 / 60)
}
